module.exports = __webpack_public_path__ + "img/PKW_Polizei.9c3a6228.svg";